import { AlertService, IAlertModalPayload, } from '@aurelia-toolkit/alert';

export interface IWithAlertService {
  alertService: AlertService;
}

export function usingTraceAwareProgress(errorMessage?: string | Partial<IAlertModalPayload> | ((e: any) => string), allowCancel: boolean = false) {
  // eslint-disable-next-line @typescript-eslint/ban-types
  return function usingProgressDecorator<T>(_target: IWithAlertService, _propertyKey: string, descriptor: TypedPropertyDescriptor<(this: IWithAlertService, ...args: unknown[]) => Promise<T>>) {
    const originalMethod = descriptor.value;
    if (originalMethod !== undefined) {
      descriptor.value = async function withProgress(this: IWithAlertService, ...args) {
        if (!this.alertService) {
          throw new Error('Did you forget to inject AlertService?');
        }
        const abortController = new AbortController();
        document.addEventListener('global-progress:cancel', () => abortController.abort(), { once: true });
        return this.alertService.usingProgress(async () => {
          return originalMethod.apply(this, [...args, abortController.signal]) as Promise<T>;
        }, async e => {
          let message = (errorMessage instanceof Function ? errorMessage(e) : errorMessage) ?? e.message;
          if (e.traceParent) {
            navigator.clipboard.writeText(e.traceParent);
            message += '<br> Tracing information was copied to clipboard. Please send it to support.';
          }
          if (e.nonCritical) {
            await this.alertService.error({ html: message });
          } else {
            await this.alertService.criticalError({ html: message }, e);
          }
          throw e;
        }, allowCancel);
      };
    }
    return descriptor;
  };
}
